<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 13 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
cx="6.5"
cy="11.5"
r="6.5"
:fill="color"
/>
        <path
            d="M6.044 13.12V7.396H7.1V13.12H6.044ZM6.044 16V14.512H7.1V16H6.044Z"
            fill="white"
        />
    </svg>
</template>

<script>
export default {
    name: 'CheckSvg',
    props: {
        color: {
            type: String,
            default: 'currentColor',
        },
        width: {
            type: Number,
            default: 13,
        },
        height: {
            type: Number,
            default: 24,
        },
    },
}
</script>
